import React from "react"
import styled from "styled-components"

interface SelectButtonProps {
  outline: boolean
}
export const SelectButton = styled.button<SelectButtonProps>(({ outline }) => ({
  padding: "8px 32px",
  background: "white",
  textAlign: "left",
  fontFamily: '"Gotham A", "Gotham B", sans-serif',
  fontSize: "16px",
  lineHeight: "150%",
  borderRadius: "20px",
  border: `2px solid ${outline ? "#E48400" : "#e4840000"}`,
  cursor: "pointer",
  ":focus,:hover": {
    background: "#f9ead5"
  },
  ":disabled": {
    color: "#CCCCCC",
    cursor: "not-allowed",
    background: "#F5F5F5",
    border: `2px solid ${outline ? "#CCCCCC" : "#F5F5F5"}`,
    ":focus,:hover": {
      background: "#F5F5F5"
    }
  }
}))
